import React, { useState } from "react";
import { useTheme } from "../../context/ThemeContext";

import Facebook from "../../assets/SocialMediaMockupGeneratorToolAssets/images/facebook.png";
import Instagram from "../../assets/SocialMediaMockupGeneratorToolAssets/images/instagram.png";
import Twitter from "../../assets/SocialMediaMockupGeneratorToolAssets/images/twitter.png";
import Linkedin from "../../assets/SocialMediaMockupGeneratorToolAssets/images/linkedin.png";
import Snapchat from "../../assets/SocialMediaMockupGeneratorToolAssets/images/snapchat.png";
import Tiktok from "../../assets/SocialMediaMockupGeneratorToolAssets/images/tiktok.svg";
import Reddit from "../../assets/SocialMediaMockupGeneratorToolAssets/images/reddit.svg";
import Pinterest from "../../assets/SocialMediaMockupGeneratorToolAssets/images/pinterest.svg";
import Google from "../../assets/SocialMediaMockupGeneratorToolAssets/images/google.svg";
import HeaderSection from "../../components/HeaderSection/HeaderSection";
import BottomSection from "../../components/BottomSection/BottomSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

// Social Mockup forms
import FacebookMockup from "../../components/SocialMediaMockupGeneratorToolComponents/SocialPlatforms/Facebook";

// Style
import "../../assets/SocialMediaMockupGeneratorToolAssets/App.css";

const networks = [
    { id: "facebook", name: "Facebook", icon: Facebook },
    { id: "instagram", name: "Instagram", icon: Instagram },
    { id: "twitter", name: "Twitter", icon: Twitter },
    { id: "linkedin", name: "LinkedIn", icon: Linkedin },
    { id: "snapchat", name: "Snapchat", icon: Snapchat },
    { id: "tiktok", name: "Tiktok", icon: Tiktok },
    { id: "reddit", name: "Reddit", icon: Reddit },
    { id: "pinterest", name: "Pinterest", icon: Pinterest },
    { id: "google", name: "Google", icon: Google },
];

function SocialMediaMockupGenerator() {
    const [selectedTab, setSelectedTab] = useState(0);
    const { darkMode } = useTheme();
    const [selectedNetwork, setSelectedNetwork] = useState("");

    const handleNextClick = () => {
        if (selectedNetwork) {
            setSelectedTab(1);
        }
    };

    const renderComponent = () => {
        switch (selectedNetwork) {
            case "facebook":
                return <FacebookMockup />;
            // case 'instagram':
            //   return <InstagramComponent />;
            // case 'twitter':
            //   return <TwitterComponent />;
            // case 'linkedin':
            //   return <LinkedinComponent />;
            // // Add other cases for networks
            default:
                return (
                    <div>Please select a network to preview the mockup.</div>
                );
        }
    };

    return (
        <>
            <HeaderSection toolId="socialMediaMockup" />
            <section className="max-w-4xl mx-auto p-4  lg:max-w-full lg:px-4">
                <div className="bg-white dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 rounded-xl shadow-sm dark:shadow-gray-900/10 dark:shadow-gray-900/10 dark:shadow-gray-900/10 dark:shadow-gray-900/10 dark:shadow-gray-900/10 dark:shadow-gray-900/10 border border-gray-200 dark:border-gray-700 dark:border-gray-700 dark:border-gray-700 dark:border-gray-700 dark:border-gray-700 dark:border-gray-700 overflow-hidden">
                    <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 text-white">
                        <h1 className="text-2xl font-bold mb-2 flex items-center">
                            <FontAwesomeIcon
                                icon={faEnvelope}
                                className="mr-3"
                            />
                            Social Media Mockup Generator
                        </h1>
                        <p className="opacity-90">
                            Generate social media mockup in real-time with
                            comprehensive validation checks
                        </p>
                    </div>
                    <div className="mockup-wrapper dark:text-white p-4 md:p-7">
                        <div className="mockup-heading">
                            <h2>
                                <span>Social media mockup</span>
                                <br /> generator
                            </h2>
                            <p className="dark:text-white">
                                Create stunning social media ad mockups in
                                seconds! Effortlessly customize your mockups
                                with our advanced tools—simply upload HTML5,
                                video, or image files to bring your vision to
                                life. Boost your creative process and streamline
                                your ad design workflow. Try it today!
                            </p>
                        </div>

                        <div className="mockup-tab-heading">
                            <button
                                onClick={() => setSelectedTab(0)}
                                className={`${
                                    selectedTab === 0 ? "active" : "inactive"
                                } ${selectedTab !== 0 ? "disabled" : ""}`}
                                disabled={selectedTab !== 0}
                            >
                                1. Select Network
                            </button>
                            <button
                                onClick={() => setSelectedTab(1)}
                                className={`${
                                    selectedTab === 1 ? "active" : "inactive"
                                } ${selectedTab !== 1 ? "disabled" : ""}`}
                                disabled={selectedTab !== 1}
                            >
                                2. Creating mockup
                            </button>
                        </div>

                        {selectedTab === 0 && (
                            <>
                                <div className="selecting">
                                    <div className="social-select">
                                        {networks.map((network) => (
                                            <label
                                                key={network.id}
                                                className={`network-label ${
                                                    selectedNetwork ===
                                                    network.id
                                                        ? "social-tab-selected"
                                                        : ""
                                                }`}
                                            >
                                                <img
                                                    src={network.icon}
                                                    alt={`${network.name} icon`}
                                                />
                                                <span>{network.name}</span>
                                                <input
                                                    type="radio"
                                                    name="network"
                                                    value={network.id}
                                                    checked={
                                                        selectedNetwork ===
                                                        network.id
                                                    }
                                                    onChange={() =>
                                                        setSelectedNetwork(
                                                            network.id
                                                        )
                                                    }
                                                />
                                            </label>
                                        ))}
                                    </div>
                                    <div className="mockup-name">
                                        <label htmlFor="mockupName">
                                            Name for mockup
                                        </label>
                                        <input
                                            type="text"
                                            id="mockupName"
                                            placeholder="Enter name for mockup"
                                        />
                                    </div>
                                </div>
                            </>
                        )}

                        {selectedTab === 1 && (
                            <div className="preview-form-main">
                                {renderComponent()}
                            </div>
                        )}

                        <div className="main-mockup-buttons">
                            {selectedTab === 1 && (
                                <button
                                    className="prev-mock-button mx-auto"
                                    onClick={() => setSelectedTab(0)}
                                >
                                    Previous Step
                                </button>
                            )}
                            {selectedTab === 0 ? (
                                <button
                                    className="submit-button mx-auto"
                                    onClick={handleNextClick}
                                    disabled={!selectedNetwork}
                                >
                                    Next Step
                                </button>
                            ) : (
                                <button
                                    className="submit-button mx-auto"
                                    onClick={handleNextClick}
                                    disabled={!selectedNetwork}
                                >
                                    Next Step
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </section>
            <BottomSection toolId="socialMediaMockup" />
        </>
    );
}

export default SocialMediaMockupGenerator;
